export const LegendType = {
	RED_PLAN: { SvgClassName: "r", Text: "NUMBER OF PLANS IN STATUS \"DRAFT\"" },
	ORANGE_PLAN: { SvgClassName: "o", Text: "NUMBER OF PLANS IN STATUS \"SUBMITTED\"" },
	GREEN_PLAN: { SvgClassName: "g", Text: "NUMBER OF PLANS IN STATUS \"PLANNED\"" },
    RED_REPORT: { SvgClassName: "r", Text: "NUMBER OF REPORTS IN STATUS \"OPENED\"" },
	ORANGE_REPORT: { SvgClassName: "o", Text: "NUMBER OF REPORTS IN STATUS \"SUBMITTED\"" },
	GREEN_REPORT: { SvgClassName: "g", Text: "NUMBER OF REPORTS IN STATUS \"COMPLETED\"" },
};